import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useApprovalsQuery } from '@access-cms/api-client';

function useApprovalDetailsSequence() {
  const { id } = useParams();
  const approvalsQuery = useApprovalsQuery();
  const approvals = approvalsQuery.data?.data ?? [];

  const currentApprovalIndex = useMemo(() => {
    if (!approvals.length) {
      return -1;
    }

    return approvals.findIndex((approval) => approval.application_id === id);
  }, [approvals, id]);

  const previousApproval = currentApprovalIndex > 0 ? approvals[currentApprovalIndex - 1] : null;
  const nextApproval =
    currentApprovalIndex >= 0 && currentApprovalIndex < approvals.length - 1
      ? approvals[currentApprovalIndex + 1]
      : null;

  return {
    currentApprovalIndex,
    nextApproval,
    previousApproval,
  };
}

export default useApprovalDetailsSequence;
